import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=54002362&scoped=true&"
import script from "./Imprint.vue?vue&type=script&lang=ts&"
export * from "./Imprint.vue?vue&type=script&lang=ts&"
import style0 from "./Imprint.vue?vue&type=style&index=0&id=54002362&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54002362",
  null
  
)

export default component.exports